<template>
<div class="container-box">
    <div class="mask-bar" :style="{width:width}"></div>
    <div :id="id" :style="{height:height,width:width}"></div>
</div>
</template>

<script>
import echarts from 'echarts';
export default {
    props: ['className', 'id', 'height', 'width', 'title', 'echartsData'],
    data() {
        return {
            currentIndex: ''
        }
    },
    mounted() {
        let dataAxis = [];
        let data = [];
        this.echartsData.map(item => {
            dataAxis.push(item.areaName);
            data.push(item.num);
        })
        this.currentIndex = dataAxis.length;
        this.initData(data.reverse(), dataAxis.reverse());
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {

        initData(data, dataAxis) {
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(document.getElementById(this.id))
            // 绘制图表
            myChart.setOption({
                grid: {
                    left: '3%',
                    right: '10%',
                    // bottom: '3%',
                    top: '1%',
                    bottom: '0',
                    containLabel: true
                },
                yAxis: {
                    data: dataAxis,
                    axisLabel: {
                        outside: true,
                        textStyle: {
                            color: '#04C3F1'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    z: 5
                },
                xAxis: {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    show: false,
                },
                dataZoom: [{
                    type: 'inside',
                    zoomOnMouseWheel: true,
                    moveOnMouseWheel: true,
                    orient: 'vertical',
                    startValue: dataAxis.length,
                    endValue: dataAxis.length - 10
                }],
                series: [{
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'right',
                        color: '#04C3F1'
                    },
                    barWidth: '50%',
                    barMaxWidth: '10%',
                    barCategoryGap: '10%',
                    itemStyle: {
                        borderColor: '#04C3F1',
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 1, 0,
                            [{
                                    offset: 0,
                                    color: 'transparent'
                                },
                                {
                                    offset: 1,
                                    color: '#04C3F1'
                                }
                            ]
                        )
                    },
                    data: data
                }]
            })
            const that = this;
            this.timer = setInterval(function () {
                that.currentIndex = that.currentIndex - 1;
                if (that.currentIndex == 10) {
                    // clearInterval(this.timer)
                    that.currentIndex = dataAxis.length;
                }
                myChart.dispatchAction({
                    type: 'dataZoom',
                    startValue: that.currentIndex,
                    endValue: that.currentIndex - 10
                });
            }, 1000);
        }
    },
}
</script>

<style lang="less" scoped>
.container-box {
    position: relative;
    height: calc(60vh - 50px - 15px - 30px - 20px);

    .mask-bar {
        height: 0;
        left: 20px;
        position: absolute;
        background: linear-gradient(to bottom, transparent, #19455a);
        bottom: 20px;
        z-index: 9;
        box-shadow: 20px 20px #19455a;
    }
}
</style>
